// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.navigation-tabs-item {
  padding: 8px 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  position: relative;
  height: 48px;
  max-width: 800px;
  color: var(--color-navigation-tabs-content);
}
.navigation-tabs-item:hover {
  color: var(--color-navigation-tabs-hover);
}
.navigation-tabs-item--active {
  position: relative;
  color: var(--color-navigation-tabs-active);
}
.navigation-tabs-item--active:after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: var(--color-navigation-tabs-active);
  z-index: 2;
}
.navigation-tabs-item--disabled {
  pointer-events: none;
  color: var(--color-content-secondary);
}
.navigation-tabs-item__text {
  overflow: hidden;
}
.navigation-tabs-item--first-tab {
  margin-left: 0;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/navigation-tabs/NavigationTabsItem.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,2CAAA;AASF;AAPE;EACE,yCAAA;AASJ;AANE;EACE,kBAAA;EACA,0CAAA;AAQJ;AANI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,qDAAA;EACA,UAAA;AAQN;AAJE;EACE,oBAAA;EACA,qCAAA;AAMJ;AAHE;EACE,gBAAA;AAKJ;AAFE;EACE,cAAA;AAIJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n.navigation-tabs-item {\n  padding: @layoutUnit-sm @layoutUnit-lg;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  position: relative;\n  height: 48px;\n  max-width: 800px;\n  color: var(--color-navigation-tabs-content);\n\n  &:hover {\n    color: var(--color-navigation-tabs-hover);\n  }\n\n  &--active {\n    position: relative;\n    color: var(--color-navigation-tabs-active);\n\n    &:after {\n      content: '';\n      position: absolute;\n      bottom: -2px;\n      left: 0;\n      right: 0;\n      height: 2px;\n      background-color: var(--color-navigation-tabs-active);\n      z-index: 2;\n    }\n  }\n\n  &--disabled {\n    pointer-events: none;\n    color: var(--color-content-secondary);\n  }\n\n  &__text {\n    overflow: hidden;\n  }\n\n  &--first-tab {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
